import { render, staticRenderFns } from "./RankingGlosas.vue?vue&type=template&id=a466b702"
import script from "./RankingGlosas.vue?vue&type=script&lang=js"
export * from "./RankingGlosas.vue?vue&type=script&lang=js"
import style0 from "./RankingGlosas.vue?vue&type=style&index=0&id=a466b702&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports